module.exports = __webpack_public_path__ + "static/media/FONDO-PAGINA-NO-ENCONTRADA.80f49e2b.png";